import {MAIL_TYPE, PASS_GRADE} from "./enum";

export const isObject = (val) => typeof val === 'object' && val !== null;

export const getValueColor = (val) => {
    if (typeof val === 'string') return '#008000';
    if (typeof val === 'number') return '#1c00cf';
    if (typeof val === 'boolean') return '#aa0d91';
    if (val === null) return '#808080';
    return '#000';
};

export const getMailTypeColorAndText = (mailType) => {
    let color, text;
    switch (mailType) {
        case MAIL_TYPE.ADMIN:
            color = 'red';
            text = '운영(수동)';
            break;
        case MAIL_TYPE.COUPON:
            color = 'green';
            text = '쿠폰';
            break;
        case MAIL_TYPE.PURCHASE:
            color = 'blue';
            text = '인앱구매';
            break;
        case MAIL_TYPE.EVENT:
            color = 'purple';
            text = '이벤트';
            break;
        case MAIL_TYPE.CHEAT:
            color = 'orange';
            text = '치트';
            break;
        case MAIL_TYPE.ADMIN_AUTO:
            color = 'cyan';
            text = '운영(자동)';
            break;
        default:
            color = 'default';
            text = 'Unknown';
    }

    return {color, text};
}

// 패스 상태 추출 함수
export const getCurrentPassStatus = (passData) => {
    if (!passData || !Array.isArray(passData.purchasedProduct) || passData.purchasedProduct.length === 0) {
        return null;
    }
    const lastGrade = passData.purchasedProduct[passData.purchasedProduct?.length - 1];
    return getPassGradeText(lastGrade % 10);
};

const getPassGradeText = (grade) => {
    switch (grade) {
        case PASS_GRADE.VIP:
            return 'VIP';
        case PASS_GRADE.UPGRADE_TO_LUXURY:
            return 'VIP→럭셔리';
        case PASS_GRADE.LUXURY:
            return '럭셔리';
        case PASS_GRADE.LAST_CHANCE:
            return '마지막 기회';
        default:
            return '알 수 없음';
    }
};